var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 6v2.667m0 2.666h.007m-.93-8.738-5.484 9.47c-.304.526-.456.789-.433 1.004.02.188.118.36.27.47.176.128.48.128 1.087.128h10.966c.607 0 .91 0 1.086-.128a.67.67 0 0 0 .271-.47c.022-.215-.13-.478-.434-1.003L8.923 2.595c-.303-.524-.455-.786-.652-.874a.67.67 0 0 0-.542 0c-.198.088-.35.35-.652.874"
  })));
};
export default SvgAlertTriangle;